import { render, staticRenderFns } from "./KBEUI_dataTable.vue?vue&type=template&id=7c979074"
import script from "./KBEUI_dataTable.vue?vue&type=script&lang=js"
export * from "./KBEUI_dataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports